import { useEffect } from "react";

export default function Analytics({ config }) {
  useEffect(() => {
    if (!config) return;
    const add = (id, fn) => {
      if (!id || document.getElementById(`an-${id}`)) return;
      fn(id);
    };
    add(config.ga_id, (id) => {
      const s = document.createElement("script");
      s.id = `an-${id}`; s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
      document.head.appendChild(s);
      const c = document.createElement("script");
      c.innerHTML = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${id}');`;
      document.head.appendChild(c);
    });
    add(config.gtm_id, (id) => {
      const c = document.createElement("script");
      c.id = `an-${id}`;
      c.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${id}');`;
      document.head.appendChild(c);
    });
    add(config.meta_pixel_id, (id) => {
      const c = document.createElement("script");
      c.id = `an-${id}`;
      c.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${id}');fbq('track','PageView');`;
      document.head.appendChild(c);
    });
  }, [config]);
  return null;
}
